import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ResultsLegFragment, SegmentWithTransferFragment } from '@websky/graphql';
import { CheckinCardItem } from '@shared/CheckinCard';
import { useTheme } from '../../../theme';
import { getTotalDurationLabel, getTransferLabel } from '../../utils';

interface Props {
	segment: SegmentWithTransferFragment;
	isLast: boolean;
	multipleSegments: boolean;
	flight?: ResultsLegFragment;
	children: React.ReactNode;
}

const SegmentDelimiterItem: React.FC<Props> = ({ segment, isLast, multipleSegments, flight, children }) => {
	const { t } = useTranslation('DesktopFlightInfo');
	const { DesktopFlightRouteStyles: theme } = useTheme('DesktopFlightRoute');

	const { transferDuration } = segment;
	const isTotalDuration = isLast && multipleSegments && !!flight;

	let delimiterText: string;

	if (isTotalDuration) {
		delimiterText = getTotalDurationLabel(t, flight);
	} else if (!isLast && transferDuration) {
		delimiterText = getTransferLabel(t, segment.segment.arrival.airport.name, transferDuration);
	}

	const hasDelimiter = !isLast || isTotalDuration;

	return (
		<CheckinCardItem
			className={theme.checkinCardItem__container}
			classes={{
				content: theme.segmentItem,
				delimiterText: isTotalDuration ? theme.totalDurationText : theme.transferText
			}}
			delimiter={hasDelimiter ? 'dashed' : undefined}
			delimiterText={delimiterText}
		>
			{children}
		</CheckinCardItem>
	);
};

export default SegmentDelimiterItem;
